var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "basic-header hidden-print" },
    [
      _c("nav", { staticClass: "navbar-suite" }, [
        _c("div", { staticClass: "nav-inner-wrap" }, [
          _c(
            "div",
            {
              staticClass: "col-sm-4 col-md-3 col-xs-10",
              attrs: { id: "navbar-students" }
            },
            [
              _vm.role !== "none"
                ? _c(
                    "ul",
                    {
                      staticClass: "nav navbar-nav navbar-left",
                      staticStyle: { display: "block" },
                      attrs: { role: "navigation" }
                    },
                    [
                      _c("li", { staticClass: "dropdown" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-toggle nowrap",
                            attrs: {
                              "data-toggle": "dropdown",
                              role: "button",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.studentDropdownIsExpanded = !_vm.studentDropdownIsExpanded
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "navbar-student-image img-circle"
                              },
                              [
                                !!_vm.selectedStudent
                                  ? _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: _vm.selectedStudent.PHOTO_URL,
                                        alt: _vm.selectedStudent.NAME
                                      }
                                    })
                                  : _c("img", {
                                      staticClass:
                                        "img-fluid default-profile-img",
                                      attrs: {
                                        src:
                                          "/CommunityWebPortal/_app/includes/static/images/profiles/no-image.png",
                                        alt: "Default profile image"
                                      }
                                    })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip.bottom-center",
                                    value: {
                                      content: !!_vm.selectedStudent
                                        ? _vm.selectedStudent.FIRST_NAME +
                                          " " +
                                          _vm.selectedStudent.LAST_NAME
                                        : _vm.$t(
                                            "MAIN_CONTENT.Header.selectAStudent"
                                          ),
                                      trigger: "hover click"
                                    },
                                    expression:
                                      "{\n\t\t\t\t\t\t\t\t\tcontent: !!selectedStudent ? `${ selectedStudent.FIRST_NAME } ${ selectedStudent.LAST_NAME }` :\n\t\t\t\t\t\t\t\t\t\t$t('MAIN_CONTENT.Header.selectAStudent'),\n\t\t\t\t\t\t\t\t\ttrigger: 'hover click'\n\t\t\t\t\t\t\t\t}",
                                    modifiers: { "bottom-center": true }
                                  }
                                ],
                                staticClass: "navbar-selected-student-name"
                              },
                              [
                                !!_vm.selectedStudent
                                  ? [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.selectedStudent.FIRST_NAME
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.selectedStudent.LAST_NAME
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.Header.selectAStudent"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                _vm._v(" "),
                                !_vm.studentDropdownIsExpanded
                                  ? _c("font-awesome-icon", {
                                      attrs: { icon: "chevron-down" }
                                    })
                                  : _c("font-awesome-icon", {
                                      attrs: { icon: "chevron-up" }
                                    })
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu",
                            class: {
                              "show-menu": _vm.studentDropdownIsExpanded
                            }
                          },
                          [
                            _vm.role === "student"
                              ? _c(
                                  "li",
                                  {
                                    staticClass:
                                      "dropdown-header selected-student-header-item"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.Header.myStudentProfileTitleCase"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : !!_vm.selectedStudent
                              ? _c(
                                  "li",
                                  {
                                    staticClass:
                                      "dropdown-header selected-student-header-item"
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.Header.currentStudentProfileTitleCase"
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !!_vm.selectedStudent
                              ? _c(
                                  "li",
                                  { staticClass: "selected-student-item" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "pointer",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.setSelectedStudentAndGoToWelcomeScreen(
                                              _vm.selectedStudent.STUDENT_RID
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            { staticClass: "col-xs-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "navbar-student-image img-circle"
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "img-fluid",
                                                    attrs: {
                                                      src:
                                                        _vm.selectedStudent
                                                          .PHOTO_URL,
                                                      alt:
                                                        _vm.selectedStudent.NAME
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-xs-9" },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedStudent
                                                      .FIRST_NAME
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.selectedStudent
                                                        .LAST_NAME
                                                    )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "ul",
                                                {
                                                  staticClass: "list-unstyled"
                                                },
                                                _vm._l(
                                                  _vm.selectedStudent
                                                    .ENROLLMENT,
                                                  function(school, index) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key:
                                                          school.SCHOOL_ID +
                                                          "_" +
                                                          index
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "MAIN_CONTENT.commonContent.sideMenuGradeLabel"
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              school.GRADE_LEVEL
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                        _c("br"),
                                                        _vm._v(
                                                          _vm._s(
                                                            school.SCHOOL_TITLE
                                                          ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.role === "parent"
                              ? _c("li", { staticClass: "dropdown-header" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.Header.sideNavMyStudents"
                                      )
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.unselectedStudents, function(student) {
                              return _c(
                                "li",
                                {
                                  key: student.STUDENT_RID,
                                  staticClass: "student-item"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setSelectedStudentAndGoToWelcomeScreen(
                                            student.STUDENT_RID
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-xs-3" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "navbar-student-image img-circle"
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "img-fluid",
                                                attrs: {
                                                  src: student.PHOTO_URL,
                                                  alt: student.NAME
                                                }
                                              })
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-xs-9" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(student.FIRST_NAME) +
                                                " " +
                                                _vm._s(student.LAST_NAME)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            { staticClass: "list-unstyled" },
                                            _vm._l(student.ENROLLMENT, function(
                                              school,
                                              index
                                            ) {
                                              return _c(
                                                "li",
                                                {
                                                  key:
                                                    school.SCHOOL_ID +
                                                    "_" +
                                                    index
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "MAIN_CONTENT.commonContent.sideMenuGradeLabel"
                                                        )
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        school.GRADE_LEVEL
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    _vm._s(
                                                      school.SCHOOL_TITLE
                                                    ) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-sm-3 col-md-5 hidden-xs text-center",
              attrs: { id: "navbar-brand" }
            },
            [
              _c("h1", { staticClass: "header-title" }, [
                _c("i", {
                  class: "sf sf-" + _vm.suiteModule,
                  attrs: { "aria-hidden": "true", title: _vm.title }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: { "sr-only": _vm.srOnly, "visible-lg-inline": true }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t\t"
                    )
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showNav
            ? _c(
                "div",
                {
                  staticClass: "col-xs-2 col-sm-5 col-md-4 text-right",
                  attrs: { id: "navbar-account" }
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "nav navbar-nav navbar-right",
                      staticStyle: { display: "block" },
                      attrs: { role: "navigation" }
                    },
                    [
                      _vm.role !== "none"
                        ? _c("li", { staticClass: "active hidden-xs" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    return _vm.navigateToHomePage()
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "home" }
                                }),
                                _vm._v(" "),
                                !_vm.isAboveMaxLength()
                                  ? [
                                      _c(
                                        "span",
                                        { staticClass: "visible-lg-inline" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(
                                                  "MAIN_CONTENT.commonContent.homeHeaderLink"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t(
                                                "MAIN_CONTENT.commonContent.currentHeaderLabel"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "hidden-xs" },
                        [
                          _c("help-button", {
                            attrs: {
                              linkClass: "rudder-help",
                              disableText: !_vm.isAboveMaxLength()
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("li", { staticClass: "dropdown" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-toggle text-right",
                            attrs: {
                              href: "#",
                              "data-toggle": "dropdown",
                              role: "button",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.isExpanded = !_vm.isExpanded
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "hidden-xs" },
                              [
                                _vm.role === "student"
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("MAIN_CONTENT.Header.account")
                                        )
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        _vm._s(_vm.profile.USER_FIRST_NAME) +
                                          " " +
                                          _vm._s(_vm.profile.USER_LAST_NAME)
                                      )
                                    ],
                                _vm._v(" "),
                                !_vm.isExpanded
                                  ? _c("font-awesome-icon", {
                                      staticStyle: { color: "#FFFFFF" },
                                      attrs: { icon: "chevron-down" }
                                    })
                                  : _c("font-awesome-icon", {
                                      staticStyle: { color: "#FFFFFF" },
                                      attrs: { icon: "chevron-up" }
                                    })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "visible-xs-inline" },
                              [
                                _c("font-awesome-icon", {
                                  staticStyle: { color: "#FFFFFF" },
                                  attrs: { icon: "ellipsis-v" }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu",
                            class: { "show-menu": _vm.isExpanded }
                          },
                          [
                            _vm.role !== "none" && !_vm.userIsAdmin
                              ? _c("li", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "pointer",
                                      on: {
                                        click: function($event) {
                                          return _vm.updateRoute(
                                            "/account-settings/general"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.Header.accountSettingsHeaderLabel"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.userIsAdmin
                              ? [
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0);" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.switchAdminRole($event)
                                          }
                                        }
                                      },
                                      [
                                        _vm.role === "student"
                                          ? [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.Header.switchToParentView"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.role === "parent"
                                          ? [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MAIN_CONTENT.Header.switchToStudentView"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "javascript:void(0);" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.showLocaleDialog = true
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.$t(
                                                "MAIN_CONTENT.Header.changeLanguage"
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: { click: _vm.logout }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.Header.logoutHeaderLabel"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ])
                          ],
                          2
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.showLocaleDialog
        ? [
            _c(
              "modal",
              {
                attrs: {
                  "modal-title": _vm.$t(
                    "MAIN_CONTENT.General.languageSelectionTitle"
                  ),
                  show: _vm.showLocaleDialog,
                  "dialog-size": "sm",
                  name: "courseRequestModal"
                },
                on: {
                  close: function($event) {
                    !_vm.selectedLocale && _vm.$store.state.role !== "admin"
                      ? ""
                      : (_vm.showLocaleDialog = false)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(modalProps) {
                        return [
                          _c("p", { staticClass: "text-center text-muted" }, [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.General.languageSelectionTitle"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12" }, [
                            _c("strong", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.General.selectLanguage"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedLocale,
                                    expression: "selectedLocale"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  name: "localeSelection",
                                  id: "localeSelect"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedLocale = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.locales, function(
                                locale,
                                localeIndex
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: "locale_" + localeIndex,
                                    domProps: { value: locale.LOCALE_ID }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(locale.LOCALE_DISPLAY_TEXT) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2159092838
                )
              },
              [
                _vm._v(" "),
                _c("template", { slot: "footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-transparent pull-right",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.switchLanguageDisplay()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.commonContent.submitButton")
                          ) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ])
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }